import { Link } from "react-router";

interface ISSHRefProps {
  children: string;
  href: string;
  openInNewTab?: boolean;
}

const SSHRef: React.FC<ISSHRefProps> = ({ children, href, openInNewTab }) => {
  if (openInNewTab)
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        className="text-secret-purple-default"
      >
        {children}
      </a>
    );

  return (
    <Link to={href} className="text-secret-purple-default">
      {children}
    </Link>
  );
};

export default SSHRef;
